import { SimpleGrid } from "@chakra-ui/react";
import CreatureCard from "./creatureCard";
import { useContext, useEffect, useMemo, useState } from "react";
import { getCreatureDetailsHelper } from "@/app/helpers/getCreatureDetailsHelper";
import { CreaturesConst } from "@/app/const/creaturesConst";
import { getFeedLevelFromTimestamp, getLaughLevelFromTimestamp } from "@/app/helpers/getFeedLevelFromTimestamp";
import { GlobalDataContext } from "@/app/context/global/globalDataContext";
import { GlobalDataUserContext } from "@/app/context/global/globalDataUserContext";

type Props = {
    shadow?: boolean;
};
export default function MyCreatures({shadow}:Props) {

    const {
        categoryId        
    } = useContext(GlobalDataContext)

    const {
        myCreatures,
        config
    } = useContext(GlobalDataUserContext)

    const [creatureIdPuffing, setCreatureIdPuffing] = useState<string|null>(null);
    
    useEffect(() => {
        if ( !config || !config.allowFart) {
            return;
        }
        const getRandomMonsterId = () => {
            const randomIndex = Math.floor(Math.random() * (myCreatures?.length || 0));
            return myCreatures && myCreatures[randomIndex]?.id;
        };
        
        const updatePuffingId = () => {
            if ( !config || !config.allowFart){
                return
            }
        setCreatureIdPuffing(getRandomMonsterId());
        
            // Définir un nouveau timeout avec une durée aléatoire
            const interval = Math.random() * (120000 - 5000) + 5000; // Intervalle aléatoire entre 5 et 120 secondes
            clearTimeout(timer);
            timer = setTimeout(updatePuffingId, interval);
        };

        // Démarrer la première exécution
        let timer = setTimeout(updatePuffingId, Math.random() * (120000 - 5000) + 5000);

        return () => clearTimeout(timer);
    }, [config]);

        const creatureCounts = useMemo(() => {
            return myCreatures?.reduce((acc: any, creature) => {
                acc[creature.creatureId] = (acc[creature.creatureId] || 0) + 1;
                return acc;
            }, {});
        }, [myCreatures]);

        const creatureDetails = useMemo(() => {
            return myCreatures?.reduce((acc:any, creature) => {
            acc[creature.creatureId] = getCreatureDetailsHelper(creature.creatureId);
            return acc;
            }, {});
        }, [myCreatures]);

        const sortedCreatures = useMemo(() => {
            const renderedCounts:any = {};
            return myCreatures && myCreatures.sort((a, b) => {
                const nameComparison = creatureDetails[a.creatureId]!.name.localeCompare(creatureDetails[b.creatureId]!.name);
                return nameComparison !== 0 ? nameComparison : a.discovered - b.discovered;
            }).filter(creature => creatureDetails[creature.creatureId]!.category == categoryId)
            .map(creature => {
                const { creatureId } = creature;
                // Initialiser le compteur si nécessaire
                if (!renderedCounts[creatureId]) {
                    renderedCounts[creatureId] = 0;
                }
                // Incrémenter le compteur pour cette créature
                renderedCounts[creatureId] += 1;
        
                // Vérifier si la créature est un doublon mais pas la première occurrence
                const isDuplicate = creatureCounts[creatureId] > 1 && renderedCounts[creatureId] > 1;
                return { ...creature, isDuplicate };
            });
        }, [myCreatures, categoryId]);
      
        const sortedConstCreatures = useMemo(() => {
            return CreaturesConst.sort((a, b) => a.name.localeCompare(b.name)).filter(creature => creature.category == categoryId && !myCreatures?.some(myCreature => myCreature.creatureId == creature.id));
        },[myCreatures, categoryId]);
    

    if ( shadow) {
        return (<>{ sortedCreatures && <SimpleGrid columns={{base:2,md:3,lg:4}} spacing={5} w="full" p={5}>
            {sortedCreatures?.slice(0, 8).map((creature) => {
                return <CreatureCard key={creature.id} id={creature.id} creatureId={creature.creatureId} eating={getFeedLevelFromTimestamp(creature.lastFeed)} laughing={0} available={true}/>
            }) }     
            {sortedConstCreatures?.slice(0, 8 - sortedCreatures.length).map((creature) => {
                return <CreatureCard key={creature.id} id={creature.id}  creatureId={creature.id} eating={100} laughing={0} available={false}/>
            })}
        </SimpleGrid> }</>)
    }
    return (
        <>
            <SimpleGrid zIndex={2} columns={{base:2,md:3,lg:4}} spacing={5} w="full" p={5} pt={0}>
                {sortedCreatures && <>
                    {sortedCreatures?.map((creature) => {
                        return  <CreatureCard key={creature.id} id={creature.id} creatureId={creature.creatureId} shouldPuff={creatureIdPuffing==creature.id} double={creature.isDuplicate} eating={getFeedLevelFromTimestamp(creature.lastFeed)} laughing={getLaughLevelFromTimestamp(creature.lastLaugh || 0)} available={true} isNew={creature.discovered > ( new Date(Date.now() - 12 * 60 * 60 * 1000).getTime() )}/> 
                    })}
                </>
                }
                {sortedConstCreatures?.map((creature) => {
                    return <CreatureCard key={creature.id} id={creature.id}  creatureId={creature.id} eating={100} laughing={5} available={false}/>
                })}
            </SimpleGrid> 
        </>
    )
}